/**
 * Дисклеймер подвала «БАД. Не является лекарственным средством. Необходима
 * консультация специалиста» — в одну строку во всю ширину, кегль по доле
 * площади экрана (заказчик, 19–21.10.2026: одна строка, шрифт из макета,
 * 10% для БАДа по рамкам букв).
 *
 * Разметка — include/views/footer-disclaimer.php:
 *
 *   <div class="footer-disclaimer__text js-disclaimer-fit"
 *        data-ratio="0.1" data-mode="bbox"
 *        data-min-scale-x="0.05" data-max-scale-y="1">БАД. …</div>
 *
 * Порог и трактовка площади живут в атрибутах, расчёт — общий модуль
 * `disclaimerFit` (template). Здесь только привязка: обёртка `__text-inner`
 * (на неё идёт scaleX), кегль из CSS как нижняя граница (на 1440 — макетные
 * 128.25), пересчёт на ресайзе и после загрузки шрифта.
 */
itsoftApp.createModule("regulatoryDisclaimer", ["disclaimerFit"], function () {
    const module = this;

    // Второй проход после ресайза: бокс ещё старый в момент события
    // (поворот телефона, панель адреса), см. скилл itsoft-disclaimer.
    const RESIZE_SETTLE_MS = 350;
    const RESIZE_DEBOUNCE_MS = 100;

    const RegulatoryDisclaimer = function () {
        this.items = Array.prototype.slice.call(document.querySelectorAll(".js-disclaimer-fit"));

        if (!this.items.length) {
            return;
        }

        this.fitApi = itsoftApp.modules.disclaimerFit.callback;
        this.timers = [];

        this.items.forEach(this.prepare, this);
        this.init();
    };

    /* Текст лежит прямо в элементе — заворачиваем его в обёртку для transform */
    RegulatoryDisclaimer.prototype.prepare = function (textEl) {
        if (!textEl.querySelector("[class$='__text-inner']")) {
            const inner = document.createElement("span");
            inner.className = textEl.classList[0] + "-inner";

            while (textEl.firstChild) {
                inner.appendChild(textEl.firstChild);
            }

            textEl.appendChild(inner);
        }

        /* С этим классом CSS держит строку одной (без JS текст переносится) */
        textEl.classList.add("_fit");
    };

    RegulatoryDisclaimer.prototype.fitItem = function (textEl) {
        const inner = textEl.querySelector("[class$='__text-inner']");

        /* Кегль из CSS — нижняя граница: снимаем инлайн прошлого прогона */
        textEl.style.fontSize = "";
        const minSize = parseFloat(window.getComputedStyle(textEl).fontSize) || 0;

        const result = this.fitApi.fit(textEl, inner, {
            ratio: parseFloat(textEl.getAttribute("data-ratio")) || 0.05,
            mode: textEl.getAttribute("data-mode") || "bbox",
            sxMin: parseFloat(textEl.getAttribute("data-min-scale-x")) || 0.7,
            syMax: parseFloat(textEl.getAttribute("data-max-scale-y")) || 1.5,
            singleLine: true,
            minSize: minSize
        });

        /* Высота надписи изменилась — слушает disclaimerFloat.js */
        if (typeof window.CustomEvent === "function") {
            textEl.dispatchEvent(new CustomEvent("disclaimer:fit", { bubbles: true }));
        }

        DEBUG && result && console.log("[module regulatoryDisclaimer] " +
            result.size.toFixed(2) + "px, scale " + result.scaleX.toFixed(3) + "×" +
            result.scaleY.toFixed(3) + ", доля " + (result.coverage * 100).toFixed(2) +
            "% (" + result.mode + ")" + (result.wrapped ? ", перенос" : ""));

        return result;
    };

    RegulatoryDisclaimer.prototype.fitAll = function () {
        this.items.forEach(this.fitItem, this);
    };

    RegulatoryDisclaimer.prototype.onResize = function () {
        const self = this;

        this.timers.forEach(window.clearTimeout);
        this.timers = [
            window.setTimeout(function () {
                self.fitAll();
            }, RESIZE_DEBOUNCE_MS),
            window.setTimeout(function () {
                self.fitAll();
            }, RESIZE_SETTLE_MS)
        ];
    };

    RegulatoryDisclaimer.prototype.onFontsLoaded = function () {
        /* Первые замеры могли лечь с метриками запасного шрифта */
        this.fitApi.invalidateCache();
        this.fitAll();
    };

    RegulatoryDisclaimer.prototype.init = function () {
        const self = this;

        this.fitAll();

        window.addEventListener("resize", function () {
            self.onResize();
        });

        if (document.fonts) {
            if (document.fonts.ready) {
                document.fonts.ready.then(function () {
                    self.onFontsLoaded();
                });
            }

            if (document.fonts.addEventListener) {
                document.fonts.addEventListener("loadingdone", function () {
                    self.onFontsLoaded();
                });
            }
        }
    };

    module.instance = new RegulatoryDisclaimer();
    module.callback = RegulatoryDisclaimer;
});
